import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST_HEAT_DISSIPATION: 'LIST_HEAT_DISSIPATION',
  LIST_SOLAR_ABSORPTANCE: 'LIST_SOLAR_ABSORPTANCE',
};

export const listHeatDissipation = () => ({
  type: ACTION.LIST_HEAT_DISSIPATION,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_HEAT_DISSIPATION,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});

export const listSolarAbsorptance = () => ({
  type: ACTION.LIST_SOLAR_ABSORPTANCE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_SOLAR_ABSORPTANCE,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/references/envelop_actions.js